import { tokens } from '@equinor/eds-tokens';

var _tokens$colors$intera = tokens.colors.interactive,
  hoverBackgroundColor = _tokens$colors$intera.table__cell__fill_hover.rgba,
  activeBackgroundColor = _tokens$colors$intera.table__cell__fill_activated.rgba;
var token = {
  states: {
    active: {
      background: activeBackgroundColor
    },
    hover: {
      background: hoverBackgroundColor
    }
  }
};

export { token };
